import { render, staticRenderFns } from "./CreateEditSchedule.vue?vue&type=template&id=2cb140e2&scoped=true"
import script from "./CreateEditSchedule.vue?vue&type=script&lang=js"
export * from "./CreateEditSchedule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb140e2",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ScheduleEditor: require('/app/components/schedule/ScheduleEditor.vue').default})
